import * as z from 'zod'

import {buildEntrySchemaFor} from '../entry'
import {PageSettingsSchema} from './pageSettings'

export function buildPageSchemaForTemplate<Template extends z.ZodType>(templateSchema: Template) {
  return buildEntrySchemaFor('containerPage', {
    fields: z.lazy(() =>
      z.object({
        path: z.string(),
        settings: PageSettingsSchema.optional(),
        template: templateSchema,
        title: z.string(),
      }),
    ),
  })
}
